'use client'

import moment from 'moment'
import Link from 'next/link'
import { useEffect } from 'react'

export default function AwardWinningVisitor() {
  useEffect(() => {
    const now = moment()
    const end = moment().add(7, 'days')

    const data = window.localStorage.getItem('visitante_premiado')

    if (data === null || now > moment(JSON.parse(data))) {
      window.localStorage.setItem('visitante_premiado', JSON.stringify(end))
      let item: any = document.getElementById('modal_visitante_premiado')
      item!.showModal()
    }
  }, [])

  return (
    <dialog id="modal_visitante_premiado" className="modal">
      <div className="modal-box border-0 p-0">
        <div className="bg-footer py-4 text-white">
          <form method="dialog">
            <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2 focus-visible:outline-none">
              ✕
            </button>
          </form>
          <p className="mt-4 text-center text-lg font-bold md:mt-0">
            Visitante Premiado - Bolsa Desconto
          </p>
        </div>
        <div className="bg-white p-6">
          <p className="pb-4 text-black">
            <b>Parabéns!</b> Você Ganhou 1 Bolsa Desconto para iniciar sua
            Graduação ou Pós-graduação EAD na Faculdade Metropolitana - Nota
            Máxima no MEC!
          </p>
          <div className="grid grid-cols-1 justify-center -space-y-2">
            <Link
              href="https://wa.me/5516993174699?text=Sou%20Visitante%20Premiado%20com%20Bolsa%20de%20Desconto%20para%20Gradua%C3%A7%C3%A3o%20EAD%2FSemipresencial%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.%20Cupom%20%23QREGKCVZ"
              className="md:w-100 btn btn-sm mx-auto flex min-h-[55px] w-[340px] border-0 bg-verdeBtn p-2 capitalize leading-3 text-white hover:scale-105 hover:bg-verdeBtn hover:text-white"
              target="new"
            >
              Quero uma Bolsa para <b>Graduação EAD</b>
            </Link>
            <br />
            <Link
              href="https://wa.me/5516993174699?text=Ganhei%20uma%20Bolsa%20de%20Desconto%20para%20Gradua%C3%A7%C3%A3o%20Presencial%20da%20Faculdade%20Metropolitana%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.%20Cupom%20%23OMSGNZTP"
              className="md:w-100 btn btn-sm mx-auto flex min-h-[55px] w-[340px] border-0 bg-verdeBtn p-2 capitalize leading-3 text-white hover:scale-105 hover:bg-verdeBtn hover:text-white"
              target="new"
            >
              Quero uma Bolsa para <b>Graduação Presencial - Administração</b>
            </Link>
            <br />
            <Link
              href="https://wa.me/5516993174699?text=Sou%20Visitante%20Premiado%20com%20Bolsa%20de%20Desconto%20para%20P%C3%B3s-gradua%C3%A7%C3%A3o%20EAD%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.%20Cupom%20%23W32NXULE"
              className="md:w-100 btn btn-sm mx-auto flex min-h-[60px] w-[340px] border-0 bg-verdeBtn p-2 capitalize leading-3 text-white hover:scale-105 hover:bg-verdeBtn hover:text-white"
              target="new"
            >
              Quero uma Bolsa para <b>Pós-Graduação EAD <br />
                <span className='block mt-1'>
                *exclusivo para quem já tem graduação
                </span></b>
            </Link>
            <br />
          </div>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  )
}
